/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {passphrase} from 'common/yup/customs/passphrase';
import {enums} from './enums';

export const DBSettings = yup.object({
   dbType: yup.string().oneOf(enums.dbType.keys),
   sqlDbType: yup
      .string()
      .when('dbType', {
         is: enums.dbType.enum.SQL,
         then: yup.string().oneOf(enums.sqlDbType.keys),
         otherwise: yup.string().nullable(),
      })
      .default(enums.sqlDbType.enum.SQL_SERVER),
   dbName: yup.string(),
   dbUser: yup.string(),
   dbPassword: passphrase(),
   dbHost: yup.string(),
   dbPort: yup.number().integer(),
   useWindowsAuthentication: yup.boolean(),
   skipTableCreation: yup.boolean(),
   customDriver: yup.string(),
   customUrl: yup.string(),
});
export type IDBSettings = yup.InferType<typeof DBSettings>;
